import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../../../shared/environment.service';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  baseUrl = `${this.env.apiUrl}/locations`;
  headers = this.env.getCommonHeaders();
  constructor(public http: HttpClient, public env: EnvironmentService) {}
  fetchOrgLocations(id: any) {
    let url = `locations/organisation/${id}`;
    return this.env.get(url);
  }

  fetchSingleLocations(locId: any) {
    let url = `locations/${locId}`;
    return this.env.get(url);
  }

  updateLocation(locId: any, params: any) {
    let url = `locations/${locId}`;
    return this.env.put(url, params);
  }
  fetchLocationPolicy(locId: any){
    let url = `location-policy/${locId}`;
    return this.env.get(url);
  }
  saveLocationPolicy(params:any){
    let url = `location-policy`;
    return this.env.post(url, params);
}
updateLocationPolicy(policyId:any, params: any) {
  let url = `location-policy/${policyId}`;
  return this.env.put(url,params);
}
  fetchLocWithDepts(locId: any) {
    let url = `locations/detailed/${locId}`;
    return this.env.get(url);
  }
  saveLocation(params: any) {
    let url = `locations`;
    return this.env.post(url, params);
  }

  updateLocActive(locId: any, params: any) {
    let url = `locations/${locId}`;
    return this.env.patch(url, params);
  }

  deleteLocation(locId:any){
    let url = `locations/${locId}`
    return this.env.delete(url)
  }
}
